import React, { Component } from "react";
import { connect } from "react-redux";
import {
  refreshUsersAgents,
  addChatSimult,
  addChat,
  typingadd,
  CallConsultaInterna
} from "../actions";
import chatinternal from "../reducers/chatinternal";
import _ from "lodash";
import TimeCounterChatInternal from "./TimeCounterChatInternal";
import Moment, { duration } from 'moment'

var view = false;

const mapDispatchToProps = dispatch => {
  return {
    testeeditar: (post, nome) => {
      dispatch(refreshUsersAgents(post, nome));
    },
    InitialChat: (iduser, displayname, view, ramal) => {
      let datatime = Moment().format('YYYY/MM/DD HH:mm:ss');
      dispatch(addChatSimult(iduser, displayname, view,false, ramal,datatime));
      dispatch(addChat(iduser, displayname, view,false, ramal, datatime));
      dispatch(typingadd(iduser, displayname));
    },
    ConsultaInternaCall: (number,iduser,agents) => {
      dispatch(CallConsultaInterna(number,iduser,agents));
    }
  };
};

const mapStateToProps = state => {
  return {
    listCallQueue: state.listcallqueue,
    UserGroups: state.groups,
    usersatd: state.agents,
    ChatSimult: state.chatsimult,
    Messages: state.messages,
    IPCurrent: state.ipcurrent,
    InfoUsers: state.informationusers,
  };
};

class Groupsatd extends Component {
  constructor(props) {
    super(props);
    var storageGroup = localStorage.getItem('atendant_filter_group') || []
    if(storageGroup.length !== 0){
      storageGroup = storageGroup.split(',').map(Number);
    }
    this.state = {
      nameCli: "Cliente",
      filterAgent: "",
      keyGen: storageGroup,
      auxkeyGen: storageGroup,
      filterGroup: "",
      RetractExpand: "Expandir todos",
      marked: "Marcar Todos",
      checked: false,
      expandcollapse: "expand",
      queueid: -1,
      filter: "",
      unfold: "unfold_more",
      buttonRetract: false,
      buttonslimgroup: true,
      groups: [],
      expandGroup: [],
      expandUser: [],
      buttonFilterGrupo: false,
      typeGrupo: [],
      groupsview: []
    };
  }

  SlimGroup(e) {
    this.setState({ buttonslimgroup: !this.state.buttonslimgroup });
  }

  checkExpandGroup(e, idgroup) {
    var checkClick =
      this.state.expandGroup.indexOf(idgroup) != -1 ? true : false;

    if (!checkClick) {
      this.setState({
        expandGroup: this.state.expandGroup.concat([idgroup])
      });
    } else {
      this.setState({
        expandGroup: this.state.expandGroup.filter(function(val) {
          return val != idgroup;
        })
      });
    }
  }

  filterGroupAll(e, usergroups) {
    var teste = [];
    let filtersgroupstorage = []
    if (e.target.checked) {
      this.setState({ checked: true });
      this.setState({ marked: "Desmarcar Todos" });
      var myCheckbox1 = document.getElementById("groups" + "0");
      myCheckbox1.checked = true;
      usergroups.map(groups => {
        teste.push(groups.id);
        var myCheckbox = document.getElementById("groups" + groups.id);
        if (myCheckbox) myCheckbox.checked = true;
      });
      this.setState({
        keyGen: teste
      });
      filtersgroupstorage = teste
    } else {
      this.setState({ marked: "Marcar Todos" });
      this.setState({ checked: false });
      var myCheckbox1 = document.getElementById("groups" + "0");
      myCheckbox1.checked = false;
      usergroups.map(groups => {
        var myCheckbox = document.getElementById("groups" + groups.id);
        if (myCheckbox) myCheckbox.checked = false;
      });
      this.setState({ keyGen: [] });
      filtersgroupstorage = []
    }
    localStorage.setItem('atendant_filter_group', filtersgroupstorage)
  }

  checkExpandUser(e, iduser) {
    var checkClick =
      this.state.expandUser.indexOf(iduser) != -1 ? true : false;

    if (!checkClick) {
      this.setState({
        expandUser: this.state.expandUser.concat([iduser])
      });
    } else {
      this.setState({
        expandUser: this.state.expandUser.filter(function(val) {
          return val != iduser;
        })
      });
    }
  }

  InitialChat(e, chatsimult, user) {
    let erro = 0;
    if (chatsimult.length != 0) {
      chatsimult.map(chat => {
        if (parseInt(chat.iduserout) === parseInt(user.iduser)) {
          erro = 1;
        } else if (erro != 1) {
          erro = 0;
        }
      });
      if (erro === 1) {
        console.log("JA POSSUI CHAT ATIVO");
      } else {
        this.props.InitialChat(parseInt(user.iduser), user.label, "0", user.ramal);
      }
    } else {
      this.props.InitialChat(parseInt(user.iduser), user.label, "0", user.ramal);
    }
  }

  InitialCall(e,chatsimult,user){
    let erro = 0

    if(chatsimult.length != 0){
        chatsimult.map(chat =>{
          if(parseInt(chat.iduserout)===parseInt(user.iduser)){
            erro = 1;
          }else if(erro != 1){
            erro = 0;
          }
        })
      if(erro === 1){
        console.log("JA POSSUI CHAT ATIVO")
      }else{
        this.props.InitialChat(parseInt(user.iduser),user.label,true, true,user.ramal)
       this.props.ConsultaInternaCall(user.ramal,user.iduser,user);
      }
    }else{
      this.props.InitialChat(parseInt(user.iduser),user.label,true, true,user.ramal)
      this.props.ConsultaInternaCall(user.ramal,user.iduser,user);
    }
  }  

  changeAgentGroup(e, teste) {
    this.setState({ filterAgent: e.target.value });
    if (e.target.value != "") {
      this.setState({ buttonRetract: true });
      let newState = this.state.buttonRetract
        ? {
            RetractExpand: "Expandir Todos",
            expandcollapse: "expand",
            unfold: "unfold_more"
          }
        : {
            RetractExpand: "Retrair Todos",
            expandcollapse: "collapse",
            unfold: "unfold_less",
            expandGroup: []
          };
      this.setState(newState);
    } else {
      this.setState({ buttonRetract: false });
      let newState = this.state.buttonRetract
        ? {
            RetractExpand: "Expandir Todos",
            expandcollapse: "expand",
            unfold: "unfold_more"
          }
        : {
            RetractExpand: "Retrair Todos",
            expandcollapse: "collapse",
            unfold: "unfold_less",
            expandGroup: []
          };
      this.setState(newState);
    }
    if (e.target.value != "") {
      this.setState({ keyGen: [] });
    }
    if (e.target.value === "") {
      this.setState({ keyGen: this.state.auxkeyGen });
    }
  }

  DisplayAgentGroups(e) {
    e.preventDefault();
    this.setState({ buttonRetract: !this.state.buttonRetract });
    let newState = this.state.buttonRetract
      ? {
          RetractExpand: "Expandir Todos",
          expandcollapse: "expand",
          unfold: "unfold_more"
        }
      : {
          RetractExpand: "Retrair Todos",
          expandcollapse: "collapse",
          unfold: "unfold_less",
          expandGroup: []
        };
    this.setState(newState);
  }

  DisplayFiltros(e) {
    e.preventDefault();
    this.setState({ buttonfilterConsulted: !this.state.buttonfilterConsulted });
  }

  filterGroup(e, idgroup) {
    let filtersgroupstorage = []
    if (e.target.checked) {
      this.setState({
        keyGen: this.state.keyGen.concat([idgroup])
      });
      this.setState({
        auxkeyGen: this.state.auxkeyGen.concat([idgroup])
      });
      filtersgroupstorage = this.state.keyGen.concat([idgroup])
    } else {
      this.setState({
        keyGen: this.state.keyGen.filter(function(val) {
          return val != idgroup;
        })
      });
      this.setState({
        auxkeyGen: this.state.auxkeyGen.filter(function(val) {
          return val != idgroup;
        })
      });
      this.setState({ marked: "Marcar Todos" });
      this.setState({ checked: false });
      filtersgroupstorage = this.state.auxkeyGen.filter(function(val) { return val != idgroup;})
    }
    localStorage.setItem('atendant_filter_group', filtersgroupstorage)
  }

  render() {
    const { UserGroups, usersatd, ChatSimult, Messages, IPCurrent, InfoUsers } = this.props;

    var filter = [];

    if (UserGroups.length != 0) {
      this.state.groupsview = UserGroups.groups;
      this.state.groups = UserGroups.groups;

      if (this.state.keyGen !="") {
        this.state.groups = this.state.groups.filter(group =>
          this.state.keyGen.includes(group.id)
        );
      }
    } else {
      this.state.grupos = [];
    }

    if (usersatd.length != 0) {
      this.state.lsusersatd = usersatd;
    } else {
      this.state.lsusersatd = [];
    }

    const list = this.state.lsusersatd || [];
    this.state.lsusersatd = _.filter(list, agent => {
      let arrayAgent = [
        agent.username,
        agent.desc_grupo,
        agent.ramal,
        agent.razao_bloqueio
      ];
      return !_.isEmpty(this.state.filterAgent)
        ? arrayAgent.toString().toLowerCase().indexOf(this.state.filterAgent.toString().toLowerCase()) >
            -1
        : true;
    });

    {
      this.state.lsusersatd.map(user =>
        (() => {
          filter = filter.concat([user.id_grupo]);
        })()
      );
    }

    if (this.state.groups != 0) {
      this.state.groups = this.state.groups.filter(group =>
        filter.includes(group.id)
      );
    }

    this.state.lsusersatd = this.state.lsusersatd.filter(agent => agent.iduser !== InfoUsers.id)

    if (this.state.buttonslimgroup === true) {
      return (
        <div className={this.state.buttonslimgroup ? "column-model  w-20 chat-atendente active" : "column-model  w-20 chat-atendente"} id="grupos">
          <div className="column-model__header">
            <div className="column-model__header__title">
              <button
                type="submit"
                className="column-model__header__title__btn tippy-default"
                onClick={event => this.SlimGroup(event)}
                data-tippy-content="Ocultar"
              >
                <i className="material-icons">arrow_back</i>
              </button>
              <div className="text">Grupos</div>
            </div>

            <div className="column-model__header__select">
              <div
                className={
                  this.state.buttonfilterConsulted
                    ? "select with-icons active"
                    : "select with-icons"
                }
              >
                <button
                  onClick={event => this.DisplayFiltros(event)}
                  className="select__btn"
                  type="button"
                  data-pausa="Atendimento Presencial Cliente"
                >
                  Filtros
                  <i className="select__icon material-icons">
                    keyboard_arrow_right
                  </i>
                </button>
                <div className="options">
                  <ul>
                    <li>
                      <input
                        type="checkbox"
                        checked={this.state.checked}
                        name="groups0"
                        id="groups0"
                        onChange={event =>
                          this.filterGroupAll(event, this.state.groupsview)
                        }
                      />{" "}
                      <label htmlFor="groups0">{this.state.marked}</label>
                    </li>
                    {this.state.groupsview.map(group => (
                      <li key={group.id}>
                        <input
                          type="checkbox"
                          onChange={event => this.filterGroup(event, group.id)}
                          name={"groups" + group.id}
                          id={"groups" + group.id}
                          defaultChecked={this.state.keyGen.findIndex(function(val) {return val===group.id}) !== -1 ? true:false}
                        />{" "}
                        <label htmlFor={"groups" + group.id}>
                          {group.name}
                        </label>
                      </li>
                    ))}
                    <a
                      className="btn btn-primary"
                      id="check-friend-apply-filters"
                      onClick={event => this.DisplayFiltros(event)}
                    >
                      Close
                    </a>
                  </ul>
                </div>
              </div>
            </div>

            <div className="form-full">
              <div className="full-search">
                <input
                  type="text"
                  name="client-search"
                  id="client-search"
                  onChange={event => this.changeAgentGroup(event, "teste")}
                  placeholder="Pesquise aqui..."
                />
                <button type="submit" className="full-search__btn">
                  {/* <i className="material-icons">{this.state.unfold}</i> */}
                  <i className="material-icons">search</i>
                </button>
              </div>
            </div>
          </div>
            <div className="column-model__body">
              <a onClick={event => this.DisplayAgentGroups(event)}  className="column-model__body__fold" data-action={this.state.expandcollapse} id="expand-all-group">
                <i className="material-icons">unfold_more</i>
                <p className="text">{this.state.RetractExpand}</p>
              </a>
              <div className="column-model__body__content">
                <div className="list">
                  {this.state.groups.map(group => (
                    <div className="item item--groups" key={group.id}>
                      <div className={this.state.buttonRetract || this.state.expandGroup.indexOf(group.id) != -1 ? "inner inner__atendentes active" : "inner inner__atendentes"} key={group.id}>
                        <div className="title title__atendentes" key={group.id}>
                          <div className="title__top">
                            <div
                              className="about-user"
                              onClick={event =>
                                this.checkExpandGroup(event, group.id)
                              }
                            >
                              <div className="group is-poppings">
                                {group.name}
                              </div>
                            </div>
                            <div className="actions">
                              <a className="phone" data-tippy="">
                                <i className="material-icons">more_vert</i>
                              </a>
                              <a className="info">
                                <i
                                  className="chevron_right material-icons"
                                  onClick={event =>
                                    this.checkExpandGroup(event, group.id)
                                  }
                                >
                                  chevron_right
                                </i>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="details-atendentes">
                        {this.state.lsusersatd.map(user => (
                          (() => {
                            if(parseInt(group.id)==parseInt(user.id_grupo)){
                              return (
                                  <div className="item-atendentes" >
                                    <div className="title">
                                      <div className="title__top">
                                        <div className="about-user about-user--atend">
                                          <div className="nome nome--atendente" key={user.iduser} onClick={event => this.checkExpandUser(event, user.iduser)}>
                                            <span className="nome__text nome__text--tec is-poppins">{user.username}</span>
                                          </div>
                                            {(() => {
                                              if (
                                              user.status_sip === null ||
                                              user.status === null
                                            ) {
                                              return (
                                                <div className="status-time pausa-content pausa-btn--inativo tippy-default" data-tippy-content="Ativo" tabIndex="0">
                                                  <i className="material-icons">call</i>
                                                  Inativo
                                                </div>
                                              );
                                            } else if (
                                              user.status_sip === "LV" &&
                                              user.status === "LV"
                                            ) {
                                              return (
                                                <div className="status-time pausa-content pausa-btn--livre tippy-default" data-tippy-content="Ativo" tabIndex="0">
                                                  <i className="material-icons">call</i>
                                                  Livre
                                                </div>
                                              );
                                            } else if (
                                              user.status_sip === "LV" &&
                                              user.status === "AT"
                                            ) {
                                              return (
                                                <div className="status-time pausa-content pausa-btn--chmd-ativa  tippy-default" data-tippy-content="Ativo" tabIndex="0">
                                                  <i className="material-icons">call</i>
                                                  Ativo
                                                </div>
                                              );
                                            } else if (
                                              user.status_sip === "RV" &&
                                              user.status === "ATOS"
                                            ) {
                                              return (
                                                <div className="status-time pausa-content pausa-btn--chmd-ativa  tippy-default" data-tippy-content="Ativo" tabIndex="0">
                                                  <i className="material-icons">call</i>
                                                  Ativo
                                                </div>
                                              );
                                            } else if (
                                              user.status_sip === "LV" &&
                                              user.status === "RV"
                                            ) {
                                              return (
                                                <div className="status-time pausa-content pausa-btn--chmd-ativa  tippy-default" data-tippy-content="Ativo" tabIndex="0">
                                                  <i className="material-icons">call</i>
                                                  Ativo
                                                </div>
                                              );
                                            } else if (
                                              user.status_sip === "BQ" &&
                                              user.razao_bloqueio != ""
                                            ) {
                                              return (
                                                <div className="status-time pausa-content pausa-btn--pausado tippy-default" data-tippy-content="Ativo" tabIndex="0">
                                                  <i className="material-icons">call</i>
                                                  Pausado
                                                </div>
                                              );
                                            } else if (
                                              user.status_sip === "ACW" &&
                                              user.status === "ACW"
                                            ) {
                                              return (
                                                <div className="status-time pausa-content pausa-btn--after-call tippy-default" data-tippy-content="Ativo" tabIndex="0">
                                                  <i className="material-icons">call</i>
                                                  AfterCallWork
                                                </div>
                                              );
                                            } else if (
                                              user.status_sip === "CHND" &&
                                              user.razao_bloqueio != "CHND"
                                            ) {
                                              return (
                                                <div className="status-time pausa-content pausa-btn--chmd-ativa  tippy-default" data-tippy-content="Ativo" tabIndex="0">
                                                  <i className="material-icons">call</i>
                                                  Ativo
                                                </div>
                                              );
                                            }else{
                                              return (
                                                <div className="status-time pausa-content pausa-btn--inativo tippy-default" data-tippy-content="Ativo" tabIndex="0">
                                                  <i className="material-icons">call</i>
                                                  Inativo
                                                </div>
                                              );
                                            }
                                          })()}
                                      </div>
                                      <div className="about-user-info">
                                        <div className="user-time active">
                                        {
                                          (() => {
                                            let duracao = ''
                                            if(user.duration != null){
                                              let arrayCompA        = user.duration.split("-");
                                              let datatimeCompA     = Moment().format('YYYY/MM/DD HH:mm:ss');
                                              var valorDiferenca    = parseInt(Math.abs(Math.round(IPCurrent.difftime)));

                                              if(parseInt(IPCurrent.difftime)<0){
                                                datatimeCompA = Moment().subtract(valorDiferenca,'seconds').format('YYYY/MM/DD HH:mm:ss');
                                              }else{
                                                datatimeCompA = Moment().add(valorDiferenca,'seconds').format('YYYY/MM/DD HH:mm:ss');
                                              }


                                              let dataStatusA       = Moment(arrayCompA[0], 'DD/MM/YYYY HH:mm:ss').format('YYYY/MM/DD HH:mm:ss');
                                                  duracao           = Moment(datatimeCompA).diff(dataStatusA, 'seconds');
                                                  duracao=duracao<0?0:duracao;

                                            }

                                            if(user.status === null){
                                                return (
                                                  <><i className="material-icons">query_builder</i> <span className="time">00:00:00</span></>
                                                );
                                            }else if(user.status_sip === null && user.status === 'LV'){
                                                return (
                                                  <><i className="material-icons">query_builder</i> <span className="time">00:00:00</span></>
                                                );
                                            }else{
                                              return (
                                                      <div key={"intmng"+user.value+"_"+ user.status_sip+user.speaknum} style={{display: 'flex'}}>
                                                        <i className="material-icons">query_builder</i> <span className="time"><TimeCounterChatInternal horario={parseInt(duracao)} key={user.iduser+"_"+ user.status_sip}/></span>
                                                      </div>
                                              );
                                            }
                                          })()
                                          }
                                        </div>
                                        

                                        {(() => {
                                          
                                          // if((user.status==="AT" && parseInt(user.mediaid)===1)||(user.status === null)||(user.status_sip === null)){
                                            return(
                                              <div className="actions actions--nowrap">
                                                {/* <a className="phone disable" data-tippy="Voz">
                                                  <i className="material-icons">call</i></a> */}
                                                <a onClick={event => this.InitialChat(event, ChatSimult,user)} className="phone" data-tippy="Abrir chat">
                                                  <i className="material-icons">sms</i>
                                                </a>
                                              </div>
                                            )
                                          // }else{
                                          //   return(
                                          //     <div className="actions actions--nowrap">
                                          //       <a onClick={event => this.InitialCall(event, ChatSimult,user)} className="phone " data-tippy="Voz">
                                          //         <i className="material-icons">call</i></a>
                                          //       <a onClick={event => this.InitialChat(event, ChatSimult,user)} className="phone" data-tippy="Abrir chat">
                                          //         <i className="material-icons">sms</i>
                                          //       </a>
                                          //     </div>
                                          //   )
                                          // }

                                        })()}  


                                      </div>
                                      <div className={this.state.expandUser.indexOf(user.iduser) != -1 ? "details active" : "details"}> 
                                      {(() => {
                                        let duracao = ''
                                        if(user.duration !== null){
                                          let arrayCompA        = user.duration.split("-");
                                          let datatimeCompA     = Moment().format('YYYY/MM/DD HH:mm:ss');
                                          var valorDiferenca    = parseInt(Math.abs(Math.round(IPCurrent.difftime)));

                                          if(parseInt(IPCurrent.difftime)<0){
                                            datatimeCompA = Moment().subtract(valorDiferenca,'seconds').format('YYYY/MM/DD HH:mm:ss');
                                          }else{
                                            datatimeCompA = Moment().add(valorDiferenca,'seconds').format('YYYY/MM/DD HH:mm:ss');
                                          }


                                          let dataStatusA       = Moment(arrayCompA[0], 'DD/MM/YYYY HH:mm:ss').format('YYYY/MM/DD HH:mm:ss');
                                              duracao           = Moment(datatimeCompA).diff(dataStatusA, 'seconds');
                                              duracao=duracao<0?0:duracao;
                                        }
                                          if (
                                            user.status_sip === null ||
                                            user.status === null
                                          ) {
                                            return (
                                              <div className="item details__text">
                                                Status: Deslogado
                                              </div>
                                            );
                                          } else if (
                                            user.status_sip === "LV" &&
                                            user.status === "LV"
                                          ) {
                                            return (
                                              <div>
                                                <div className="item details__text">
                                                  Status: Livre
                                                </div>
                                                <div className="item details__text">
                                                  Duração:{" "}
                                                  <TimeCounterChatInternal
                                                    horario={parseInt(duracao)}
                                                  />
                                                </div>
                                              </div>
                                            );
                                          } else if (
                                            user.status_sip === "ACW" &&
                                            user.status === "ACW"
                                          ) {
                                            return (
                                              <div>
                                                <div className="item details__text">
                                                  Status: AfterCallWork
                                                </div>
                                                <div className="item details__text">
                                                  Telefone: {user.razao_bloqueio}
                                                </div>
                                                <div className="item details__text">
                                                  Duração:{" "}
                                                  <TimeCounterChatInternal
                                                    horario={parseInt(duracao)}
                                                  />
                                                </div>
                                              </div>
                                            );
                                          } else if (
                                            user.status_sip === "LV" &&
                                            user.status === "AT"
                                          ) {
                                            return (
                                              <div>
                                                <div className="item details__text">
                                                  Atendimento: Ativo
                                                </div>
                                                <div className="item details__text">
                                                  Atendendo: {user.speaknum}
                                                </div>
                                                <div className="item details__text">
                                                  Direção: {user.direcao}
                                                </div>
                                                <div className="item details__text">
                                                  Duração:{" "}
                                                  <TimeCounterChatInternal
                                                    horario={parseInt(duracao)}
                                                  />
                                                </div>
                                              </div>
                                            );
                                          } else if (
                                            user.status_sip === "RV" &&
                                            user.status === "ATOS"
                                          ) {
                                            return (
                                              <div>
                                                <div className="item details__text">
                                                  Atendimento: Ativo
                                                </div>
                                                <div className="item details__text">
                                                  Atendendo: {user.speaknum}
                                                </div>
                                                <div className="item details__text">
                                                  Direção: {user.direcao}
                                                </div>
                                                <div className="item details__text">
                                                  Duração:{" "}
                                                  <TimeCounterChatInternal
                                                    horario={parseInt(duracao)}
                                                  />
                                                </div>
                                              </div>
                                            );
                                          } else if (
                                            user.status_sip === "LV" &&
                                            user.status === "RV"
                                          ) {
                                            return (
                                              <div>
                                                <div className="item details__text">
                                                  Atendimento: Discando
                                                </div>
                                                <div className="item details__text">
                                                  Atendendo: {user.speaknum}
                                                </div>
                                                <div className="item details__text">
                                                  Direção: {user.direcao}
                                                </div>
                                                <div className="item details__text">
                                                  Duração:{" "}
                                                  <TimeCounterChatInternal
                                                    horario={parseInt(duracao)}
                                                  />
                                                </div>
                                              </div>
                                            );
                                          } else if (
                                            user.status_sip === "BQ" &&
                                            user.razao_bloqueio != ""
                                          ) {
                                            return (
                                              <div>
                                                <div className="item details__text">
                                                  Status: Pausado
                                                </div>
                                                <div className="item details__text">
                                                  Pausa: {user.razao_bloqueio}
                                                </div>
                                                <div className="item details__text">
                                                  Duração:{" "}
                                                  <TimeCounterChatInternal
                                                    horario={parseInt(duracao)}
                                                  />
                                                </div>
                                              </div>
                                            );
                                          } else if (
                                            user.status_sip === "CHND" &&
                                            user.razao_bloqueio != "CHND"
                                          ) {
                                            return (
                                              <div>
                                                <div className="item details__text">
                                                  Atendimento: Chamando
                                                </div>
                                                <div className="item details__text">
                                                  Atendendo: {user.speaknum}
                                                </div>
                                                <div className="item details__text">
                                                  Direção: {user.direcao}
                                                </div>
                                                <div className="item details__text">
                                                  Duração:{" "}
                                                  <TimeCounterChatInternal
                                                    horario={parseInt(duracao)}
                                                  />
                                                </div>
                                              </div>
                                            );
                                          }
                                        })()}                                   
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          })()
                          ))
                        }
                        </div>
                        </div>
                      </div>
                      ))}
                  </div>
                </div>
              </div>
          </div>
        );
    }else {
      return (
        <div
          className="grupos-atend--slim w-5 active"
          onClick={event => this.SlimGroup(event)}
        >
          <span className="grupos-atend--slim__tool-tip tool-tip">Exibir</span>
          <span className="grupos-atend--slim__icon material-icons">
            arrow_forward
          </span>
          <p className="grupos-atend--slim__text is-poppins is-poppins--bold">
            Grupos
          </p>
        </div>
      );
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Groupsatd);
